import { supabase, DoctorScheduleExtended } from '../lib/supabase';
import { getTenantId } from '../contexts/TenantContext';

export const doctorScheduleExtendedService = {
  async getAll(): Promise<DoctorScheduleExtended[]> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('doctor_schedules')
      .select(`
        *,
        doctor:doctors(*)
      `)
      .eq('tenant_id', tenantId)
      .is('deleted_at', null)
      .order('day_of_week', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  async getByDoctorId(doctorId: string): Promise<DoctorScheduleExtended[]> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('doctor_schedules')
      .select(`
        *,
        doctor:doctors(*)
      `)
      .eq('tenant_id', tenantId)
      .eq('doctor_id', doctorId)
      .eq('status', 'active')
      .is('deleted_at', null)
      .order('day_of_week', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  async getById(id: string): Promise<DoctorScheduleExtended | null> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('doctor_schedules')
      .select(`
        *,
        doctor:doctors(*)
      `)
      .eq('id', id)
      .eq('tenant_id', tenantId)
      .is('deleted_at', null)
      .single();

    if (error) throw error;
    return data;
  },

  async create(schedule: Omit<DoctorScheduleExtended, 'id' | 'tenant_id' | 'created_at' | 'updated_at' | 'deleted_at' | 'doctor'>): Promise<DoctorScheduleExtended> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('doctor_schedules')
      .insert({ ...schedule, tenant_id: tenantId })
      .select(`
        *,
        doctor:doctors(*)
      `)
      .single();

    if (error) throw error;
    return data;
  },

  async update(id: string, schedule: Partial<DoctorScheduleExtended>): Promise<DoctorScheduleExtended> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('doctor_schedules')
      .update(schedule)
      .eq('id', id)
      .eq('tenant_id', tenantId)
      .select(`
        *,
        doctor:doctors(*)
      `)
      .single();

    if (error) throw error;
    return data;
  },

  async delete(id: string): Promise<void> {
    const tenantId = getTenantId();
    const { error } = await supabase
      .from('doctor_schedules')
      .update({ deleted_at: new Date().toISOString() })
      .eq('id', id)
      .eq('tenant_id', tenantId);

    if (error) throw error;
  }
};
